import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITeslimYuklemeTanim_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeslimYuklemeTanim_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Get_Helpers_LoginUserInfo: any[];
  Get_Helpers_LoginUserInfo_dummy: any[];
  Get_Yonetim_UlkeListe: any[];
  Get_Yonetim_UlkeListe_dummy: any[];
  Get_Tanim_MusteriTedarikciListe: any[];
  Get_Tanim_MusteriTedarikciListe_dummy: any[];
  Get_Tanim_MusteriNoktaById: any[];
  Get_Tanim_MusteriNoktaById_dummy: any[];
  ChangeEnabledOf: any;
  ChangeEnabledOf_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  Get_Yonetim_SehirListe_ByUlkeId: any[];
  Get_Yonetim_SehirListe_ByUlkeId_dummy: any[];
  Get_Yonetim_IlceListe_BySehirId: any[];
  Get_Yonetim_IlceListe_BySehirId_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  Add_Tanim_MusteriNokta: number;
  Add_Tanim_MusteriNokta_dummy: number;
  Update_Tanim_MusteriNokta: number;
  Update_Tanim_MusteriNokta_dummy: number;
  isComp128337Enabled: "enabled" | "disabled";
}

export class TeslimYuklemeTanim_ScreenBase extends React.PureComponent<
  ITeslimYuklemeTanim_ScreenProps,
  any
> {
  teslimyuklemetanim_128337_value_kuikaSelectBoxRef: React.RefObject<any>;
  teslimyuklemetanim_418064_value_kuikaAutoCompleteRef: React.RefObject<any>;
  teslimyuklemetanim_157471_value_kuikaAutoCompleteRef: React.RefObject<any>;
  teslimyuklemetanim_236737_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "c6cc1956-12cb-432d-b21f-5e659b8a2f67",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 891214,
          PropertyName: "value",
          Value: "YÜKLEME / TESLİMAT NOKTA TANIMI",
        },
        {
          Id: 702159,
          PropertyName: "value",
          Value: "Müşteri Bağlantısız Ortak Nokta",
        },
        { Id: 594336, PropertyName: "value", Value: "Müşteri" },
        { Id: 128337, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 767051, PropertyName: "value", Value: "Nokta Adı" },
        { Id: 607530, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 172445, PropertyName: "value", Value: "Nokta Kodu" },
        { Id: 742449, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 994318, PropertyName: "value", Value: "İlgili Kişi" },
        { Id: 293322, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 684043, PropertyName: "value", Value: "Telefon" },
        { Id: 249909, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 296617, PropertyName: "value", Value: "Ülke" },
        { Id: 418064, PropertyName: "placeholder", Value: "Search..." },
        { Id: 388090, PropertyName: "value", Value: "Şehir" },
        { Id: 157471, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 514819, PropertyName: "value", Value: "İlçe" },
        { Id: 236737, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 993158, PropertyName: "value", Value: "Açık Adres" },
        { Id: 199541, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 974814, PropertyName: "label", Value: "Vazgeç" },
        { Id: 865072, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.teslimyuklemetanim_128337_value_kuikaSelectBoxRef = React.createRef();
    this.teslimyuklemetanim_607530_value_kuikaTextInputRef = React.createRef();
    this.teslimyuklemetanim_742449_value_kuikaTextInputRef = React.createRef();
    this.teslimyuklemetanim_293322_value_kuikaTextInputRef = React.createRef();
    this.teslimyuklemetanim_249909_value_kuikaTextInputRef = React.createRef();
    this.teslimyuklemetanim_418064_value_kuikaAutoCompleteRef =
      React.createRef();
    this.teslimyuklemetanim_157471_value_kuikaAutoCompleteRef =
      React.createRef();
    this.teslimyuklemetanim_236737_value_kuikaAutoCompleteRef =
      React.createRef();
    this.teslimyuklemetanim_199541_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Get_Helpers_LoginUserInfo: [],
      Get_Yonetim_UlkeListe: [],
      Get_Tanim_MusteriTedarikciListe: [],
      Get_Tanim_MusteriNoktaById: [],
      IfThenElse: false,
      Get_Yonetim_SehirListe_ByUlkeId: [],
      Get_Yonetim_IlceListe_BySehirId: [],
      GoBack: "",
      Add_Tanim_MusteriNokta: 0,
      Update_Tanim_MusteriNokta: 0,
      isComp128337Enabled: "enabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("teslimyuklemetanim", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TeslimYuklemeTanimPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teslimyuklemetanim", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teslimyuklemetanim", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeslimYuklemeTanimPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      teslimyuklemetanim_288097_checked:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.ortakNokta ?? undefined,
      teslimyuklemetanim_128337_value:
        this.props.screenInputs.MusteriId ?? this.props.screenInputs.musteriid,
      teslimyuklemetanim_607530_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.noktaAdi ?? undefined,
      teslimyuklemetanim_742449_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.noktaKodu ?? undefined,
      teslimyuklemetanim_293322_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.ilgiliKisi ?? undefined,
      teslimyuklemetanim_249909_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.telefon ?? undefined,
      teslimyuklemetanim_418064_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.ulkeId ?? undefined,
      teslimyuklemetanim_157471_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.sehirId ?? undefined,
      teslimyuklemetanim_236737_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.ilceId ?? undefined,
      teslimyuklemetanim_199541_value:
        this.state.Get_Tanim_MusteriNoktaById?.at?.(0)?.acikAdres ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeslimYuklemeTanimPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimYuklemeTanim/TeslimYuklemeTanimPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_LoginUserInfo =
      result?.data.get_Helpers_LoginUserInfo;
    stateVars.Get_Yonetim_UlkeListe = result?.data.get_Yonetim_UlkeListe;

    formVars.teslimyuklemetanim_418064_options =
      stateVars.Get_Yonetim_UlkeListe;
    stateVars.Get_Tanim_MusteriTedarikciListe =
      result?.data.get_Tanim_MusteriTedarikciListe;

    formVars.teslimyuklemetanim_128337_options =
      stateVars.Get_Tanim_MusteriTedarikciListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimYuklemeTanimPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      NoktaId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "Guid"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimYuklemeTanim/TeslimYuklemeTanimPageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Tanim_MusteriNoktaById =
        result?.data.get_Tanim_MusteriNoktaById;
      formVars.teslimyuklemetanim_288097_checked = ReactSystemFunctions.value(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ortakNokta
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ortakNokta
          : null
      );
      formVars.teslimyuklemetanim_607530_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].noktaAdi
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].noktaAdi
          : null
      );
      formVars.teslimyuklemetanim_742449_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].noktaKodu
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].noktaKodu
          : null
      );
      formVars.teslimyuklemetanim_293322_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ilgiliKisi
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ilgiliKisi
          : null
      );
      formVars.teslimyuklemetanim_249909_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].telefon
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].telefon
          : null
      );
      formVars.teslimyuklemetanim_418064_value =
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ulkeId
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ulkeId
          : null;
      formVars.teslimyuklemetanim_157471_value =
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].sehirId
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].sehirId
          : null;
      formVars.teslimyuklemetanim_236737_value =
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ilceId
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ilceId
          : null;
      formVars.teslimyuklemetanim_199541_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].acikAdres
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].acikAdres
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_288097_checked = ReactSystemFunctions.value(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ortakNokta
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ortakNokta
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_128337 =
      stateVars.Get_Tanim_MusteriTedarikciListe ??
      this.state.Get_Tanim_MusteriTedarikciListe;
    stateVars.dataSource_128337 =
      stateVars.Get_Tanim_MusteriTedarikciListe ??
      this.state.Get_Tanim_MusteriTedarikciListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimYuklemeTanimPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_607530_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].noktaAdi
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].noktaAdi
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_742449_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].noktaKodu
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].noktaKodu
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_293322_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ilgiliKisi
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ilgiliKisi
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_249909_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].telefon
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].telefon
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimYuklemeTanimPageInit9_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_418064_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ulkeId
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ulkeId
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_418064 =
      stateVars.Get_Yonetim_UlkeListe ?? this.state.Get_Yonetim_UlkeListe;
    stateVars.dataSource_418064 =
      stateVars.Get_Yonetim_UlkeListe ?? this.state.Get_Yonetim_UlkeListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimYuklemeTanimPageInit11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_157471_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].sehirId
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].sehirId
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_236737_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].ilceId
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].ilceId
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimYuklemeTanimPageInit13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimYuklemeTanimPageInit13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.teslimyuklemetanim_199541_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriNoktaById !== undefined
          ? stateVars.Get_Tanim_MusteriNoktaById?.length > 0
            ? stateVars.Get_Tanim_MusteriNoktaById[0].acikAdres
            : null
          : this.state.Get_Tanim_MusteriNoktaById?.length > 0
          ? this.state.Get_Tanim_MusteriNoktaById[0].acikAdres
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_288097_onChange_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp128337Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("disabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_288097_onChange_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp128337Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_288097_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_288097_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.TeslimYuklemeTanimComponent_288097_onChange_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.TeslimYuklemeTanimComponent_288097_onChange_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_418064_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UlkeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_418064_value",
            "value",
            "Get_Yonetim_UlkeListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimYuklemeTanim/TeslimYuklemeTanimComponent_418064_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Yonetim_SehirListe_ByUlkeId =
      result?.data.get_Yonetim_SehirListe_ByUlkeId;

    formVars.teslimyuklemetanim_157471_options =
      stateVars.Get_Yonetim_SehirListe_ByUlkeId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimYuklemeTanimComponent_418064_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimComponent_418064_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_157471 =
      stateVars.Get_Yonetim_SehirListe_ByUlkeId ??
      this.state.Get_Yonetim_SehirListe_ByUlkeId;
    stateVars.dataSource_157471 =
      stateVars.Get_Yonetim_SehirListe_ByUlkeId ??
      this.state.Get_Yonetim_SehirListe_ByUlkeId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_418064_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UlkeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_418064_value",
            "value",
            "Get_Yonetim_UlkeListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimYuklemeTanim/TeslimYuklemeTanimComponent_418064_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Yonetim_SehirListe_ByUlkeId =
      result?.data.get_Yonetim_SehirListe_ByUlkeId;

    formVars.teslimyuklemetanim_157471_options =
      stateVars.Get_Yonetim_SehirListe_ByUlkeId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimYuklemeTanimComponent_418064_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimComponent_418064_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_157471 =
      stateVars.Get_Yonetim_SehirListe_ByUlkeId ??
      this.state.Get_Yonetim_SehirListe_ByUlkeId;
    stateVars.dataSource_157471 =
      stateVars.Get_Yonetim_SehirListe_ByUlkeId ??
      this.state.Get_Yonetim_SehirListe_ByUlkeId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_157471_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SehirId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_157471_value",
            "value",
            "Get_Yonetim_SehirListe_ByUlkeId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimYuklemeTanim/TeslimYuklemeTanimComponent_157471_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Yonetim_IlceListe_BySehirId =
      result?.data.get_Yonetim_IlceListe_BySehirId;

    formVars.teslimyuklemetanim_236737_options =
      stateVars.Get_Yonetim_IlceListe_BySehirId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimYuklemeTanimComponent_157471_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimComponent_157471_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_236737 =
      stateVars.Get_Yonetim_IlceListe_BySehirId ??
      this.state.Get_Yonetim_IlceListe_BySehirId;
    stateVars.dataSource_236737 =
      stateVars.Get_Yonetim_IlceListe_BySehirId ??
      this.state.Get_Yonetim_IlceListe_BySehirId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_974814_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "43fc490a_712c_ab21_16b0_3731dcc99abb_confirmation",
        this.defaultML,
        "Kayıt edilmeyen veriler iptal edilecek"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  TeslimYuklemeTanimComponent_865072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      OrtakMusteri_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_288097_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      AcikAdres_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_199541_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
      IlceId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_236737_value",
            "value",
            "Get_Yonetim_IlceListe_BySehirId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      IlgiliKisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_293322_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      NoktaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_607530_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      NoktaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_742449_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Telefon_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_249909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      MusteriId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriId ?? this.props.screenInputs.musteriid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimYuklemeTanim/TeslimYuklemeTanimComponent_865072_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Add_Tanim_MusteriNokta = result?.data.add_Tanim_MusteriNokta;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimYuklemeTanimComponent_865072_onClick1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimYuklemeTanimComponent_865072_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimComponent_865072_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AcikAdres_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_199541_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IlceId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_236737_value",
            "value",
            "Get_Yonetim_IlceListe_BySehirId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      IlgiliKisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_293322_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
      NoktaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_607530_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      NoktaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_742449_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Telefon_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimyuklemetanim_249909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.NoktaId ?? this.props.screenInputs.noktaid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimYuklemeTanim/TeslimYuklemeTanimComponent_865072_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Update_Tanim_MusteriNokta =
        result?.data.update_Tanim_MusteriNokta;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimYuklemeTanimComponent_865072_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimYuklemeTanimComponent_865072_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimYuklemeTanimComponent_865072_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TeslimYuklemeTanimPageInit();
    }
  }
}
